import React, { useState, useEffect, Fragment, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

// import LayoutHOC from "../../LayoutHOC";
import AddFieldDrawer from "../../GlobalFeature/Table/AddFieldDrawer";
import { useSidebar } from "../../SidebarContext";

// import MySpaceDocument from "./MySpaceDocument";
// import CsvUploadPreview from "./CsvUploadPreview";
import MenuOptionsDropdown from "./MenuOptionsToCreate";
import ManageViewDrawer from "./ManageViewDrawer";
import ErrorFallback from "./ErrorFallBack";
import { ReactComponent as NewExpandIcon } from "../../../assets/images/icons/ExpandIcon.svg";

import { ReactComponent as ClosePopUpIcn } from "../../../assets/images/closePopUpIcn.svg";
import PlusIcon from "../../../assets/images/icons/PlusIcon";
import { ReactComponent as ThreeDotMenu } from "../../../assets/images/threeDotVertical.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/deleteIconCoaTable.svg";
import { ReactComponent as PlusGrayIcon } from "../../../assets/images/icons/Blackplusicon.svg";
import { ReactComponent as CreateSomethingNew } from "../../../assets/images/create_something_new.svg";
import ManageIcon from "../../../assets/images/icons/ManageIcon";
import { ReactComponent as AddItemplus } from "../../../assets/images/icons/AddItems.svg";
import { ReactComponent as ActiveAddItem } from "../../../assets/images/icons/ActiveAddItem.svg";

import CustomerReactTable from "../../UniversalComponents/CustomerReactTable";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import HighlightedParagraph from "../../UniversalComponents/HighlightedParagraph";
import Button from "../../UniversalComponents/DefaultButton";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import TableListRowAddEditComponent from "../../UniversalComponents/BillingTableRowAddEdit";
import GetPersonAvatar from "../../UniversalComponents/GetPersonAvatar";
import Breadcrumb from "../../UniversalComponents/Breadcrumb";
import AddItemPlus from "../../UniversalComponents/AddItemPlus";

import {
  mySpaceAddColumnOptions,
  mySpaceAddField,
  mySpaceAddUpdateCell,
  mySpaceData,
  mySpaceDeleteColumns,
  mySpaceDeleteOption,
  mySpaceFieldOptions,
  mySpaceGetHeaders,
  mySpacePersonList,
  mySpaceTableBulkUpdateListValue,
  mySpaceTableColumnUpdate,
  mySpaceTableRowAddUpdate,
  mySpaceTableRowDelete,
} from "../../../utils/api/mySpaceApi";
import {
  getCompanyId,
  getMySpaceColumnOrder,
  getMySpaceVisibleFields,
  getUserToken,
  setMySpaceColumnOrder,
  setMySpaceVisibleFields,
} from "../../../utils/utilityFunctions/localServices";
import {
  useLazyFetchPersonInTableQuery,
  useFetchCustomerTableDataNewMutation,
} from "../../../utils/customer/customerTable";
import { pushAlert } from "../../../utils/alertSlice";
import { getUserTokeData } from "../../../utils/userSlice";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import {
  formatNegativeNumber,
  formatTextValue,
  getHexWithOpacity,
  IndeterminateCheckbox,
  safeJsonParse,
} from "../../../utils/utilityFunctions/stringUtility";
import ResponsiveTags from "../../../utils/utilityFunctions/ResponsiveTags";
import { hexToRgba } from "../../../utils/utilityFunctions/color";
import {
  addUpdateFieldValue,
  addUpdateHeader,
  addUpdateRow,
  deleteColumn,
  deleteColumnOption,
  deleteFieldOption,
  deleteRow,
  fetchColumnDropdownOptions,
  fetchHeaders,
  fetchHeaderValues,
} from "../../../utils/api/billingApi";
import { getCustomerId } from "../CustomerSlice";
import InternalNavigation from "../../UniversalComponents/InternalNavigation";
import ConfirmationDialogMulti from "../../UniversalComponents/ConfirmationDialogMulti";
import { getUserDateTime } from "../../../utils/utilityFunctions/UTCFormat";

const BillingDashboard = ({ customerId = null, subNavitems }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const companyId = getCompanyId();
  const navigate = useNavigate();

  //----------------------------------------------- URL TYPE AND CONTAINER ID CHECK -----------------------------------------------
  const { "*": wildcard } = useParams(); // everything after /my_space/

  const { type, urlContainerId, isShared } = useMemo(() => {
    if (!wildcard) return { type: null, urlContainerId: null, isShared: false };

    const parts = wildcard.split("/").filter(Boolean);
    const validTypes = ["folders", "tables"];

    let isShared = false;
    let type = null;
    let urlContainerId = null;

    // Case: /shared/folders or /shared/folders/:id
    if (parts[0] === "shared" && validTypes.includes(parts[1])) {
      isShared = true;
      type = parts[1];
      urlContainerId = parts[2] || null; // may be undefined
    }
    // Case: /folders or /folders/:id
    else if (validTypes.includes(parts[0])) {
      type = parts[0];
      urlContainerId = parts[1] || null;
    }

    return { type, urlContainerId, isShared };
  }, [wildcard]);

  //----------------------------------------------- URL TYPE AND CONTAINER ID CHECK -----------------------------------------------

  // TO MAKE TABLE-ID PERSISTENT IN URL FROM REFRESH
  // const queryParams = new URLSearchParams(location?.search);
  // const queryContainerId = queryParams.get("containerId")?.replace(/^"|"$/g, "");
  const [containerId, setContainerId] = useState(urlContainerId || "9949006f-66f2-11f0-a486-bc2411f4d589");
  const [showListView, setShowListView] = useState(type === "tables" ? true : false);

  // useEffect(() => {
  //   if (queryContainerId) {
  //     setContainerId(queryContainerId);
  //   }
  // }, [queryContainerId]);

  const [multiData, setMultiData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [showShareFileModal, setShowShareFileModal] = useState(false);
  const [headerConfigData, setHeaderConfigData] = useState([]);
  const [mySpaceBody, setMySpaceBodyData] = useState([]);
  const [isApiLoading, setIsApiLoading] = useState(false);
  // const [iserror, setIsError] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState();

  // const [showCsvUploadPreview, setShowCsvUploadPreview] = useState(false);
  // const [csvFileData, setCsvFileData] = useState(null);

  const [lastSelectedRowIndex, setLastSelectedRowIndex] = useState(null);
  const [grouping, setGrouping] = useState([]);

  // const [mySpaceDocumentList, setMySpaceDocumentList] = useState([]);
  const [selectedtableRowId, setSelectedtableRowId] = useState(null);
  const [rowAddEditMode, setRowAddEditMode] = useState("add");

  const [isActive, setIsActive] = useState(false);

  const [showConfirmDialog, setShowConfirmDialog] = useState({ show: false, data: {} });
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showManageViewDrawer, setShowManageViewDrawer] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({ hidden_fields: [], visible_fields: [] });
  const [tableColumnsVisibility, setTableColumnsVisibility] = useState({});
  const [menuVisible, setMenuVisible] = useState(false);
  const [isMangeHovered, setIsMangeHovered] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const [isDetailsVisible, setDetailsVisible] = useState(false);

  const [columnOrder, setColumnOrder] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [resetPageIndex, setResetPageIndex] = useState(true);
  const [extraField, setExtraField] = useState(false);
  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();
  const [fieldOptionsData, setFieldOptionsData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isEditableFieldModeActive, setIsEditableFieldModeActive] = useState(null);
  const [breadcrumpList, setBreadcrumpList] = useState([{ label: "My Space", isContainer: true }]);
  const [isActiveAddItem, setIsActiveAddItem] = useState(false);

  // const [searchParams] = useSearchParams();
  // const tableId = searchParams.get('tableId');

  const reorderVisibleFields = (listViewData, draggedIndex, targetIndex) => {
    if (
      draggedIndex < 0 ||
      targetIndex < 0 ||
      draggedIndex >= listViewData.visible_fields.length ||
      targetIndex >= listViewData.visible_fields.length
    ) {
      return listViewData; // Return unchanged if indices are invalid
    }

    // Create a copy to prevent mutation
    const updatedVisibleFields = [...listViewData.visible_fields];

    // Remove the dragged item and insert it at the target position
    const [movedItem] = updatedVisibleFields.splice(draggedIndex, 1);
    updatedVisibleFields.splice(targetIndex, 0, movedItem);

    // Return the updated listViewData with new order
    return { ...listViewData, visible_fields: updatedVisibleFields };
  };

  const handleReorderFields = (sourceIndex, targetIndex) => {
    const updatedData = reorderVisibleFields(columnVisibility, sourceIndex, targetIndex);
    setColumnVisibility(updatedData);

    // Store order state locally
    setMySpaceColumnOrder(containerId, ["select", ...updatedData.visible_fields]);

    setColumnOrder(["select", ...updatedData.visible_fields]);
  };

  const fetchFieldOptions = useCallback(
    async (data) => {
      const columnHeaderData = headerConfigData?.find((header) => header?.value === data);
      if (columnHeaderData?.type === "dropdown" || columnHeaderData?.type === "multiselect") {
        const response = await fetchColumnDropdownOptions({ query: { field_name: columnHeaderData?.value } });

        if (response?.success || response?.status) {
          if (response?.data?.length > 0) {
            // const formatedResponse = response?.data?.map((data) => {
            //   return {
            //     value: data?.label,
            //     color_code: data?.color,
            //     uuid: data?.id,
            //     field_id: columnHeaderData?.id,
            //   };
            // });
            const formatedResponse = response?.data?.map((data) => {
              return {
                ...data,
                value: data?.label,
              };
            });

            setFieldOptionsData({ success: true, data: formatedResponse });
          } else {
            setFieldOptionsData({ success: true, data: [] });
          }
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.data?.message,
              type: "danger",
            })
          );
        }
      }
    },
    [headerConfigData]
  );

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: getUserToken(), data: data, companyId: companyId?.company_id });
  };

  //For setting data in Header
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  const jsonStringFilter = (row, columnId, filterValue) => {
    const cellValue = row.getValue(columnId); // Convert to string
    return filterValue.every((filterStr) =>
      cellValue?.some((person) => person.email?.toLowerCase().includes(filterStr?.toLowerCase()))
    );
  };

  const multiSelectFilterFn = (row, columnId, filterValue) => {
    console.log("multiSelectFilterFn hit", filterValue, row.getValue(columnId));
    // If no filter is applied, return true (i.e. show the row)
    if (!filterValue || filterValue?.length === 0) return true;
    // Check if the row value is included in the selected values
    return filterValue.includes(row.getValue(columnId)?.value);
  };

  const filterColumn = (row, columnId, filterValue, headerType) => {
    const columnData = row.getValue(columnId);

    let isFound = false;

    if (filterValue?.length === 0) {
      isFound = true;
    } else {
      // For multi Select
      if (headerType == "multiselect") {
        const refineFilterValues = filterValue?.map((data) => data?.value);
        columnData?.value?.forEach((data) => {
          if (refineFilterValues.includes(data?.value)) {
            isFound = true;
          }
        });
      }
      // For single Select
      else if (headerType == "dropdown") {
        const refineFilterValues = filterValue?.map((data) => safeJsonParse(data)?.value);
        if (refineFilterValues.includes(columnData?.value?.value)) {
          isFound = true;
        }
      }
      // For Simple text/number inputs
      else if (headerType == "text" || headerType == "number") {
        if (filterValue.includes(row?.original[columnId]?.value)) {
          isFound = true;
        }
      } else {
        isFound = true;
      }
    }

    return isFound;
  };

  const handleRowSelection = (event, rowId, index, tableData) => {
    //const checkindex=tableData.getRowModel().rows.findIndex((item)=>item.original.id==rowId)

    setMultiData((prev) => {
      let newSelectedRows = { ...prev };
      let currentIndex;
      tableData.getRowModel().rows.map((item, index) => {
        if (item.original.id === rowId) {
          currentIndex = index;
        }
      });

      setLastSelectedRowIndex((prevLastIndex) => {
        if (event.shiftKey && prevLastIndex !== null) {
          const lowerIndex = Math.min(prevLastIndex, currentIndex);
          const upperIndex = Math.max(prevLastIndex, currentIndex);

          for (let i = lowerIndex; i <= upperIndex; i++) {
            newSelectedRows[tableData.getRowModel().rows[i]?.original?.id] = true;
          }
        } else {
          if (newSelectedRows[rowId]) {
            delete newSelectedRows[rowId];
          } else {
            newSelectedRows[rowId] = true;
          }
        }

        return currentIndex;
      });

      return newSelectedRows;
    });
  };

  const handleEditRow = async (rowInfo = {}) => {
    const rowData = [];
    let columnMetaType;
    let columnLabel;
    for (let columnName of Object.keys(rowInfo)) {
      columnLabel = headerConfigData.find((item) => item?.value === columnName)?.label || columnName;
      columnMetaType = null;
      // TODO - CUSTOMER TABLE IS HAVING UNNECESSARY ID COLUMN...
      if (columnName === "id") {
        continue;
      }

      // Finding column type
      let columnInfo = headerConfigData.find((item) => item?.value === columnName) || null;
      let columnDropdownOptions = [];

      // Initial value defined for text and value and updatingit later for dropdown/multiselect
      let columnValue = rowInfo[columnName]?.value;

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        if (!response?.success && !response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.label,
            color_code: data?.color,
          };
        });

        if (columnInfo?.type === "dropdown") {
          if (rowInfo[columnName]?.value?.id) {
            columnValue = [
              {
                value: rowInfo[columnName]?.value?.id,
                label: rowInfo[columnName]?.value?.value,
                color_code: rowInfo[columnName]?.value?.color,
              },
            ];
          } else {
            columnValue = [];
          }
        } else {
          if ((columnValue = rowInfo[columnName]?.value)) {
            columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
              return {
                value: cellOption?.id,
                label: cellOption?.value,
                color_code: cellOption?.color,
              };
            });
          } else {
            columnValue = [];
          }
        }
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });

        columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
          return {
            id: cellOption?.id,
            value: cellOption?.uuid,
            label: cellOption?.name,
            subLabel: cellOption?.email,
          };
        });
      } else if (columnInfo?.type === "text") {
        if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
          columnMetaType = "Hyperlink";
        }
      }

      rowData.push({
        name: columnLabel || null,
        value: columnValue || null,
        type: columnInfo?.type || null,
        options: columnDropdownOptions || null,
        id: columnInfo?.id || null,
        columnMetaType: columnMetaType || null,
        row_id: rowInfo.id,
        sectionName: columnInfo?.sectionName,
      });
    }

    setShowAddEditModal({ show: true, data: rowData });
    setRowAddEditMode("edit");
  };

  const handleAddRow = async () => {
    // Finding column type
    let rowData = [];
    for (let columnInfo of headerConfigData) {
      let columnDropdownOptions = [];
      let columnMetaType = null;

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        if (!response?.success && !response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.label,

            additionFields: { color_code: data?.color },
          };
        });
      } else if (columnInfo?.type === "text") {
        if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
          columnMetaType = "Hyperlink";
        }
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });
      } else if (columnInfo?.type === "text") {
        if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
          columnMetaType = "Hyperlink";
        }
      }

      rowData.push({
        name: columnInfo?.label || null,
        value: null, // Initial value defined for text and value and updatingit later for dropdown/multiselect
        type: columnInfo?.type || null,
        options: columnDropdownOptions || null,
        id: columnInfo?.id || null,
        columnMetaType: columnInfo?.meta?.textFormat?.textSelectedOption || null,
        row_id: null,
      });
    }
    setShowAddEditModal({ show: true, data: rowData });
  };

  const handleRowAddEditSubmit = async (formData) => {
    try {
      let finalRequestPayload = [];

      formData.forEach((inputData) => {
        if (inputData?.type === "text" || inputData?.type === "number" || inputData?.type === "date") {
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: inputData?.value } },
          ];
        } else if (inputData?.type === "multiselect") {
          const modifiedValue = inputData?.value?.map((data) => {
            return data?.value;
          });
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: modifiedValue || [] } },
          ];
        } else if (inputData?.type === "dropdown") {
          const singleSelectedValue =
            inputData?.value && inputData?.value?.length > 0 ? [inputData?.value[0]?.value] : [];
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: singleSelectedValue || [] } },
          ];
        } else if (inputData?.type === "person" || inputData?.type === "multi_person") {
          const modifiedValue = inputData?.value?.map((data) => {
            return {
              id: data?.id,
              name: data?.label,
              email: data?.subLabel,
              uuid: data?.value,
            };
          });
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: modifiedValue || [] } },
          ];
        }
      });

      let payload = {};

      let columnFieldsData = {};

      finalRequestPayload?.forEach((columnData) => {
        columnFieldsData[columnData?.field_id] = { value: columnData?.value };
      });

      payload = {
        data: {
          data: columnFieldsData,
        },
      };

      if (selectedtableRowId) {
        payload.data.row_id = selectedtableRowId;
      } else {
        payload.data.customer_id = customerId;
      }

      const response = await addUpdateRow({ body: payload });

      if (response?.success || response?.status) {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
        await fetchMySpaceHeaderConfig(containerId);
        setShowAddEditModal({});
        setSelectedtableRowId(null);
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message, type: "danger" }));
    }
  };

  const columns = useMemo(() => {
    const dynamicColumns =
      headerConfigData?.map((header, headerIndex) => ({
        accessorKey: header.value === "tasks" ? "task_date" : header.value,
        header: header.label, // Use label key for header
        meta: { position: "left", filterVariant: "select", type: header?.type, ...header?.meta },
        enableFiltering: false,
        // filterVariant: "select",

        filterFn: (row, columnId, filterValue) => filterColumn(row, columnId, filterValue, header.type),
        // ...(header.value === "delegation" ? { filterFn: jsonStringFilter } : { filterFn: multiSelectFilterFn }),
        // ...([].includes(header.value) && { enableColumnFilter: false }),
        enableColumnFilter: true,
        sortUndefined: "1", // Disable filtering by default
        cell: (info) => {
          const value = info.getValue();
          try {
            const parsedValue = safeJsonParse(value);

            if (header?.type === "multi_person" || header?.type === "person") {
              return (
                <span className="flex items-center gap-2">
                  <p className="w-fit max-w-[10vw]">
                    <GetPersonAvatar
                      personList={parsedValue?.value}
                      header={header}
                      rowKey={info.row.original?.id}
                      isDetailsVisible={isDetailsVisible}
                      setDetailsVisible={setDetailsVisible}
                    />
                    {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                    {headerIndex == 0 && info.row.original.id && (
                      // <span className="invisible group-hover:visible">
                      //   <MenuOptionsDropdown
                      //     buttonIcon={<NewExpandIcon className="rotate-90" />}
                      //     menuItems={[
                      //       {
                      //         label: "Edit",
                      //         icon: "",
                      //         onClick: () => {
                      //           handleEditRow(info?.row?.original);
                      //           setSelectedtableRowId(info?.row?.original?.id);
                      //         },
                      //       },
                      //       {
                      //         label: "Delete dsgdfhgfjn",
                      //         icon: "",
                      //         onClick: () => {
                      //           deleteSingleRowInTable([info.row.original.id]);
                      //         },
                      //       },
                      //     ]}
                      //     onOpen={() => console.log("Dropdown Opened")}
                      //     onClose={() => console.log("Dropdown Closed")}
                      //   />
                      // </span>
                      <span className="invisible group-hover:visible flex items-center gap-2">
                        {/* Expand (Edit) Icon */}
                        <NewExpandIcon
                          className="rotate-90 mr-2 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditRow(info?.row?.original);
                            setSelectedtableRowId(info?.row?.original?.id);
                          }}
                        />

                        {/* Delete Icon */}
                        <DeleteIcon
                          className="text-red-500 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowDeleteDialog({ id: info?.row?.original?.id });
                            // deleteSingleRowInTable([info.row.original.id]);
                          }}
                        />
                      </span>
                    )}
                  </p>
                </span>
                //  ---------------------------------------------------------------------------------------------------------------------------------------
              );
            } else if (header?.type === "text") {
              const { textSelectedOption } = header?.meta?.textFormat || {};
              return (
                <>
                  <span className="flex w-full gap-4 justify-between">
                    <HighlightedParagraph
                      paragraph={
                        textSelectedOption === "Hyperlink"
                          ? formatTextValue(parsedValue, textSelectedOption, true)
                          : formatTextValue(parsedValue?.value, textSelectedOption, false)
                      }
                      searchTerm={globalFilter}
                      className={"w-full"}
                    />

                    {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                    {headerIndex == 0 && info.row.original.id && (
                      // <span className="invisible group-hover:visible">
                      //   <MenuOptionsDropdown
                      //     buttonIcon={<ThreeDotMenu className="rotate-90" />}
                      //     menuItems={[
                      //       {
                      //         label: "Edit",
                      //         icon: "",
                      //         onClick: () => {
                      //           handleEditRow(info?.row?.original);
                      //           setSelectedtableRowId(info?.row?.original?.id);
                      //         },
                      //       },
                      //       {
                      //         label: "Delete",
                      //         icon: "",
                      //         onClick: () => {
                      //           deleteSingleRowInTable([info.row.original.id]);
                      //         },
                      //       },
                      //     ]}
                      //     onOpen={() => console.log("Dropdown Opened")}
                      //     onClose={() => console.log("Dropdown Closed")}
                      //   />
                      // </span>
                      <span className="invisible group-hover:visible flex items-center gap-2">
                        {/* Expand (Edit) Icon */}
                        <NewExpandIcon
                          className="rotate-90 mr-2 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditRow(info?.row?.original);
                            setSelectedtableRowId(info?.row?.original?.id);
                          }}
                        />

                        {/* Delete Icon */}
                        <DeleteIcon
                          className="text-red-500 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            // deleteSingleRowInTable([info.row.original.id]);
                            setShowDeleteDialog({ id: info?.row?.original?.id });
                          }}
                        />
                      </span>
                    )}
                  </span>
                </>
              );
            } else if (header?.type === "date") {
              return (
                <>
                  <HighlightedParagraph
                    className={"w-full"}
                    paragraph={getUserDateTime(parsedValue?.value)}
                    searchTerm={globalFilter}
                  />
                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && (
                    // <span className="invisible group-hover:visible">
                    //   <MenuOptionsDropdown
                    //     buttonIcon={<ThreeDotMenu className="rotate-90" />}
                    //     menuItems={[
                    //       {
                    //         label: "Edit",
                    //         icon: "",
                    //         onClick: () => {
                    //           handleEditRow(info?.row?.original);
                    //           setSelectedtableRowId(info?.row?.original?.id);
                    //         },
                    //       },
                    //       {
                    //         label: "Delete",
                    //         icon: "",
                    //         onClick: () => {
                    //           deleteSingleRowInTable([info.row.original.id]);
                    //         },
                    //       },
                    //     ]}
                    //     onOpen={() => console.log("Dropdown Opened")}
                    //     onClose={() => console.log("Dropdown Closed")}
                    //   />
                    // </span>
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          // deleteSingleRowInTable([info.row.original.id]);
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                        }}
                      />
                    </span>
                  )}
                </>
              );
            } else if (header?.type === "number") {
              return (
                <>
                  <HighlightedParagraph
                    paragraph={
                      header?.meta
                        ? formatNegativeNumber(
                            parsedValue?.value,
                            header?.meta?.numberFormat?.negativeFormat,
                            header?.meta?.numberFormat?.selectedOption,
                            header?.meta?.numberFormat?.decimalPlaces,
                            header?.meta?.numberFormat?.separators,
                            header?.meta?.numberFormat?.symbol
                          )
                        : parsedValue?.value?.value || parsedValue?.value
                    }
                    className={"w-full"}
                    searchTerm={globalFilter}
                  />

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && (
                    // <span className="invisible group-hover:visible">
                    //   <MenuOptionsDropdown
                    //     buttonIcon={<ThreeDotMenu className="rotate-90" />}
                    //     menuItems={[
                    //       {
                    //         label: "Edithhdhsjnsdjn",
                    //         onClick: () => {
                    //           handleEditRow(info?.row?.original);
                    //           setSelectedtableRowId(info?.row?.original?.id);
                    //         },
                    //       },
                    //       {
                    //         label: "Delete",
                    //         icon: "",
                    //         onClick: () => {
                    //           deleteSingleRowInTable([info.row.original.id]);
                    //         },
                    //       },
                    //     ]}
                    //     onOpen={() => console.log("Dropdown Opened")}
                    //     onClose={() => console.log("Dropdown Closed")}
                    //   />
                    // </span>
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          // deleteSingleRowInTable([info.row.original.id]);
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                        }}
                      />
                    </span>
                  )}
                </>
              );
            } else if (Array.isArray(parsedValue?.value) && parsedValue?.value?.length > 0) {
              return (
                <div className="flex justify-between w-full">
                  <ResponsiveTags parsedValue={parsedValue?.value} />
                  {headerIndex == 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          // deleteSingleRowInTable([info.row.original.id]);
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                        }}
                      />
                    </span>
                  )}
                </div>
              );
            } else if (typeof parsedValue === "object") {
              const hexColor =
                parsedValue?.color || parsedValue?.value?.color || parsedValue?.code
                  ? `${parsedValue.color || parsedValue?.value?.color || parsedValue.color}`
                  : undefined;
              return (
                <div
                  className={`${hexColor && "px-2 py-1"} group rounded min-w-full max-w-[10vw] text-ellipsis overflow-hidden flex justify-between items-center`}
                  style={{
                    backgroundColor: hexColor && getHexWithOpacity(hexColor, 10),
                    // backgroundColor:getHexWithOpacity('#000000', 40),
                    color: hexColor ? hexColor : "black",
                    borderRadius: "5px",
                    border: hexColor ? `0.8px solid ${hexColor}` : "none",
                  }}
                >
                  <div className="grow min-w-0">
                    <HighlightedParagraph
                      paragraph={
                        <>
                          {header?.meta
                            ? formatNegativeNumber(
                                parsedValue?.value,
                                header?.meta?.numberFormat?.negativeFormat,
                                header?.meta?.numberFormat?.selectedOption,
                                header?.meta?.numberFormat?.decimalPlaces,
                                header?.meta?.numberFormat?.separators,
                                header?.meta?.numberFormat?.symbol
                              )
                            : parsedValue?.value?.value || parsedValue?.value}
                        </>
                      }
                      className={"w-full"}
                      searchTerm={globalFilter}
                    />
                  </div>

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          // deleteSingleRowInTable([info.row.original.id]);
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                        }}
                      />
                    </span>
                  )}
                </div>
              );
            } else {
              return (
                // <div
                //   className={`py-1 rounded min-w-full max-w-[10vw] text-ellipsis overflow-hidden flex justify-between`}
                // >
                //   {parsedValue?.value || <p></p>}

                //   {/* // TO SHOW MENU ON FIRST COLUMN ONLY AND AVOID ADDING ON LAST COLUMN */}
                //   {headerIndex == 0 && info.row.original.id && (
                //     <span className="invisible group-hover:visible">
                //       <MenuOptionsDropdown
                //         buttonIcon={
                //           <span>
                //             <NewExpandIcon  className="rotate-90 mr-2" />
                //           </span>
                //         }
                //         menuItems={[
                //           {
                //             label: "Edit shruuuuuuuu",
                //             icon: "",
                //             onClick: () => {
                //               handleEditRow(info?.row?.original);
                //               setSelectedtableRowId(info?.row?.original?.id);
                //             },
                //           },
                //           {
                //             label: "Delete",
                //             icon: "",
                //             onClick: () => {
                //               deleteSingleRowInTable([info.row.original.id]);
                //             },
                //           },
                //         ]}
                //         onOpen={() => console.log("Dropdown Opened")}
                //         onClose={() => console.log("Dropdown Closed")}
                //       />
                //     </span>
                //   )}
                // </div>
                <div
                  className={`py-1 rounded min-w-full max-w-[10vw] text-ellipsis overflow-hidden flex justify-between items-center group`}
                >
                  {parsedValue?.value || <p></p>}

                  {/* Show icons only on first column and if row has ID */}
                  {headerIndex === 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible flex items-center gap-2">
                      {/* Expand (Edit) Icon */}
                      <NewExpandIcon
                        className="rotate-90 mr-2 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditRow(info?.row?.original);
                          setSelectedtableRowId(info?.row?.original?.id);
                        }}
                      />

                      {/* Delete Icon */}
                      <DeleteIcon
                        className="text-red-500 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          // deleteSingleRowInTable([info.row.original.id]);
                          setShowDeleteDialog({ id: info?.row?.original?.id });
                        }}
                      />
                    </span>
                  )}
                </div>
              );
            }
          } catch (error) {}
          return (
            <HighlightedParagraph
              paragraph={<p className="w-fit max-w-[10vw] text-ellipsis overflow-hidden ">{JSON.stringify(value)}</p>}
              searchTerm={globalFilter}
              className={"w-full"}
            />
          );
        },
      })) || [];

    const staticColumn = [
      // ...(grouping.length === 0
      //   ? [
      //       {
      //         id: "select",
      //         header: ({ table }) => {
      //           const allRows = table.getRowModel().rows;
      //           const allRowIds = allRows.map((row) => row.original.id);
      //           const allSelected = allRowIds?.every((id) => multiData[id]);
      //           const someSelected = allRowIds?.some((id) => multiData[id]);
      //           return (
      //             <IndeterminateCheckbox
      //               {...{
      //                 checked: allSelected,
      //                 indeterminate: someSelected && !allSelected,
      //                 onChange: (e) => {
      //                   if (e.target.checked) {
      //                     setLastSelectedRowIndex(null);
      //                     setMultiData((prev) => ({
      //                       ...prev,
      //                       ...Object.fromEntries(allRowIds.map((id) => [id, true])),
      //                     }));
      //                   } else {
      //                     setLastSelectedRowIndex(null);
      //                     setMultiData((prev) => {
      //                       const updated = { ...prev };
      //                       allRowIds.forEach((id) => delete updated[id]);
      //                       return updated;
      //                     });
      //                   }
      //                 },
      //               }}
      //             />
      //           );
      //         },
      //         cell: ({ row, table }) => {
      //           return (
      //             <div className="">
      //               {row?.original?.id && (
      //                 <IndeterminateCheckbox
      //                   {...{
      //                     checked: multiData[row.original.id],
      //                     disabled: !row.getCanSelect(),
      //                     indeterminate: row.getIsSomeSelected(),
      //                     onClick: (e) => handleRowSelection(e, row.original.id, row.index, table),
      //                   }}
      //                 />
      //               )}
      //             </div>
      //           );
      //         },
      //       },
      //     ]
      //   : []),
      // {
      //   id: "groupedColumn",
      //   header: ({ table }) =>
      //     grouping.length > 1
      //       ? "Group"
      //       : table
      //           .getAllColumns()
      //           .filter((col) => col.columnDef.accessorKey === grouping[0])
      //           .map((col) => col.columnDef.header)[0] || grouping[0],
      //   cell: () => null,
      // },
    ];

    // If columns are not created.
    if (headerConfigData?.length > 0) {
      return [...staticColumn, ...dynamicColumns];
    }
    return null;
  }, [headerConfigData, multiData, globalFilter]);

  const memoizedCustomerData = useMemo(() => {
    // if (globalFilter?.length > 0) {
    // }
    return mySpaceBody;
  }, [mySpaceBody, headerConfigData, globalFilter]);

  const [{ data: customerTableALL, isLoading: customerListLoading, isFetching: customerListFetching }] =
    useFetchCustomerTableDataNewMutation();

  const handleBulkFieldUpdateList = async ({ tableId, fieldId, rowsIds, value }) => {
    try {
      const response = await mySpaceTableBulkUpdateListValue({
        params: { tableId: tableId },
        body: {
          fieldId: fieldId,
          rowIds: rowsIds,
          data: { value },
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleTableFieldUpdate = async (item, field_name, cell) => {
    try {
      const columnInfo = headerConfigData?.find((header) => header?.value === cell?.column?.id);
      const row_id = cell?.row?.original?.id || "";
      let data = item;

      if (columnInfo?.type === "dropdown") {
        data = item?.id;
      }

      if (columnInfo?.type === "multiselect") {
        data = item?.map((data) => data?.id);
      }

      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });

      if (checkBoxSelectedIds?.length > 0) {
        await handleBulkFieldUpdateList({
          tableId: containerId,
          fieldId: columnInfo?.id,
          rowsIds: checkBoxSelectedIds,
          value: data,
        });
        return;
      }

      let body = {
        row_id: row_id,
        customer_id: customerId,
        field_id: columnInfo?.id,
        value: data,
      };

      const response = await addUpdateFieldValue({ body });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  // CRAETE COLUMN IN MY SPACE
  const handleAddTableColumn = async (fielddata) => {
    try {
      const body = {
        field_label: fielddata?.field_label,
        field_type: fielddata?.field_type,
        description: fielddata?.field_description,
        meta: fielddata?.meta || null,
      };

      if (
        fielddata?.field_type?.toLowerCase() === "dropdown" ||
        fielddata?.field_type?.toLowerCase() === "multiselect"
      ) {
        body.dropdown_options = fielddata?.field_options.map((data) => ({
          value: data?.value,
          color: data?.color_code,
        }));
      }

      const params = {
        tableId: containerId,
      };

      const response = await addUpdateHeader({ body });

      if (response?.success || response?.status) {
        const createdNewColumnId = response?.data?.id;

        // if (fielddata?.field_type === "dropdown") {
        //   await handleAddColumnOptions(fielddata, createdNewColumnId);
        // }
        await fetchMySpaceHeaderConfig(containerId);
        setExtraField((prev) => !prev);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleUpdateTableColumn = async (fieldData) => {
    try {
      // const params = {
      //   tableId: containerId,
      //   fieldId: fieldData?.fieldId,
      // };
      let body = {
        id: fieldData?.fieldId,
        field_label: fieldData?.field_label,
        // field_type: fieldData?.field_type,
        description: fieldData?.field_description,
      };

      if (fieldData?.field_type === "number") {
        const { negativeFormat, selectedOption, decimalPlaces, separators, symbol } =
          fieldData?.meta?.numberFormat || {};

        let newSeparators = separators;
        let newSymbol = symbol;

        switch (selectedOption) {
          case "Number":
            newSymbol = false;
            break;
          case "Percentage":
            newSeparators = false;
            newSymbol = false;
            break;
          // For "Currency", use default values (no change)
        }

        body = {
          ...fieldData,
          meta: {
            numberFormat: {
              negativeFormat,
              selectedOption,
              decimalPlaces,
              separators: newSeparators,
              symbol: newSymbol,
            },
          },
        };
      } else if (fieldData?.field_type === "dropdown" || fieldData?.field_type === "multiselect") {
        body = {
          ...body,
          dropdown_options: fieldData?.field_options?.map((option) => {
            return {
              value: option?.value,
              color: option?.color_code,
            };
          }),
        };
      }
      const response = await addUpdateHeader({ body: body });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
        setExtraField((prev) => !prev);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleDeleteTableColumnOption = async (fieldId, optionId) => {
    try {
      const response = await deleteFieldOption({
        params: {
          // fieldId: fieldId,
          optionId: optionId,
        },
      });
      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );

        let columnInfo = headerConfigData.find((item) => item?.id === fieldId) || null;

        const fieldOptionsResponse = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        const formatedOptionsResponse = fieldOptionsResponse?.data?.map((data) => {
          return {
            value: data?.label,
            color_code: data?.color,
            uuid: data?.id,
            field_id: fieldId,
          };
        });
        setIsEditableFieldModeActive((prev) => ({
          ...prev,
          field_options: formatedOptionsResponse,
        }));
        // await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleAddColumnOptions = async (fielddata, createdNewColumnId) => {
    try {
      const body = {
        option: fielddata?.field_options?.map((item) => {
          return {
            value: item?.value,
            color: item?.color_code,
          };
        }),
      };

      const response = await mySpaceAddColumnOptions({ body, params: { tableColumnId: createdNewColumnId } });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEditColumn = async (columnId) => {
    headerConfigData.map(async (item) => {
      if (item?.value === columnId?.id) {
        let optionsFormat = {
          field_name: item?.value,
          field_label: item?.label,
          field_options: [],
          field_type: item?.type,
          field_description: "",
          id: item?.id,
        };

        if (item?.type === "dropdown" || item?.type === "multiselect") {
          const fieldOptionsResponse = await fetchColumnDropdownOptions({ query: { field_name: item?.value } });
          const formatedOptionsResponse = fieldOptionsResponse?.data?.map((data) => {
            return {
              value: data?.label,
              color_code: data?.color,
              uuid: data?.id,
              field_id: item?.id,
            };
          });
          optionsFormat.field_options = formatedOptionsResponse;
        } else if (item?.type === "number") {
          Object.keys(item?.meta?.numberFormat)?.forEach((data) => {
            optionsFormat = { ...optionsFormat, [data]: item?.meta?.numberFormat[data] };
          });
        }

        setIsEditableFieldModeActive(optionsFormat);
      }
    });
    setExtraField(true);
  };

  const handleDeleteColumn = async (columnId) => {
    try {
      let column_id;
      headerConfigData.forEach(async (item) => {
        if (item?.value === columnId?.id) {
          column_id = item?.id;
        }
      });

      const response = await deleteColumn({
        params: { fieldId: column_id },
      });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const cursorloader = customerListFetching || customerListFetching || customerListLoading;

  // FETCH MY SPACE TABLE HEADERS
  const fetchMySpaceHeaderConfig = async (containerId) => {
    try {
      setIsApiLoading(true);
      const response = await fetchHeaders({});
      if (response?.success || response?.status) {
        let extractOnlyColumns = [];
        response?.data?.forEach((columnInfo) => {
          extractOnlyColumns = [
            ...extractOnlyColumns,
            ...(columnInfo?.fields?.map((columnData) => ({ ...columnData, sectionName: columnInfo?.title })) || []),
          ];
        });
        setHeaderConfigData(extractOnlyColumns);
        // const breadcrumpList = response?.path?.map((data) => {
        //   // Only root folder will be considered as container. so is Null
        //   return {
        //     label: data?.folderName,
        //     id: data?.folderId,
        //     isContainer: data?.folderId ? true : false,
        //   };
        // });
        // setBreadcrumpList(breadcrumpList || [{ label: "My Space", id: null, isContainer: true }]);
        // Defining visibility of columns based on response and previous state.
        handleManageDrawerData(extractOnlyColumns);
        await fetchMySpaceTableBodyData(containerId, extractOnlyColumns);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleManageDrawerData = (headerData) => {
    setColumnVisibility((prev) => {
      const allHeaderColumnsValue = headerData?.map((object) => object.value) || [];

      // Filter out fields that are not present in header data
      const newVisibleFields = prev?.visible_fields?.filter((value) => allHeaderColumnsValue.includes(value)) || [];
      const newHiddenFields = prev?.hidden_fields?.filter((value) => allHeaderColumnsValue.includes(value)) || [];

      // Find fields in headerData that are not in either visible or hidden, and add them to visible
      const missingFields = allHeaderColumnsValue.filter(
        (value) => !newVisibleFields.includes(value) && !newHiddenFields.includes(value)
      );

      return {
        ...prev,
        visible_fields: [...newVisibleFields, ...missingFields],
        hidden_fields: newHiddenFields,
      };
    });
  };

  const fetchMySpaceTableBodyData = async (tableId, headerData) => {
    try {
      const response = await fetchHeaderValues({});

      if (response?.success || response?.status) {
        // Factory for a fresh empty-entry based on headers
        const makeEmpty = () => createEmptyEntry(headerData);

        // Pull out and flatten each row’s entire data object
        const existingEntries = response.data.map((item) => ({
          ...item.data,
          id: item.row_id,
        }));

        // Merge defaults (empty) with actual data, ensuring all keys exist
        const filledEntries = existingEntries.map((dataObj) => ({
          ...makeEmpty(),
          ...dataObj,
        }));

        if (headerData?.length > 0) {
          // Set state: all filled rows + one completely blank row at the end
          setMySpaceBodyData([...filledEntries, makeEmpty()]);
        }
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response.data?.message || "Something Went Wrong.",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleBreadcrumpDataClicked = (data) => {
    // handleGetContainerList({ containerId: data?.id });
    let newUrl;
    if (data?.id) {
      if (isShared) {
        newUrl = `/my_space/shared/folders/${data?.id}`;
      } else {
        newUrl = `/my_space/folders/${data?.id}`;
      }
    } else {
      if (isShared) {
        newUrl = `/my_space/shared/folders`;
      } else {
        newUrl = `/my_space/folders`;
      }
    }
    navigate(newUrl, { replace: false });
  };

  const createEmptyEntry = (headerData) => {
    // Mapping through header data to create empty entry
    try {
      const emptyEntry = {};
      headerData?.forEach((header) => {
        emptyEntry[header?.value] = null;
      });
      return emptyEntry;
    } catch (error) {
      console.log(error);
    }
  };

  const deleteBulkRowsInTable = async () => {
    try {
      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });
      const response = await mySpaceTableRowDelete({
        params: { tableId: containerId },
        body: {
          rowIds: checkBoxSelectedIds ?? [],
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        setMultiData({});
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };
  const deleteSingleRowInTable = async (idsToBeDelete = null) => {
    try {
      const response = await deleteRow({
        params: { rowId: idsToBeDelete[0] },
        // body: {
        //   rowIds: idsToBeDelete ?? [],
        // },
      });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        setMultiData({});
        setShowDeleteDialog(false);
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const isMySpaceCreateColumnHtml = () => {
    return (
      <div className="w-full h-full bg-gray-100 flex justify-center items-center">
        <div className="w-full h-full flex flex-col justify-center items-center">
          <CreateSomethingNew className="w-[400px] h-[300px]" />
          <Button
            onClick={() => {
              setExtraField(true);
            }}
            className="!w-[300px]"
          >
            + Create First Column
          </Button>
        </div>
      </div>
    );
  };

  const handleFieldVisibility = (data) => {
    setColumnVisibility((prev) => {
      if (prev.hidden_fields.includes(data)) {
        prev.hidden_fields?.splice(prev.hidden_fields?.indexOf(data), 1);
        return {
          visible_fields: [...prev.visible_fields, data],
          hidden_fields: [...prev.hidden_fields],
        };
      } else {
        if (prev.visible_fields?.includes(data)) {
          prev.visible_fields?.splice(prev.visible_fields?.indexOf(data), 1);
        }
        return {
          visible_fields: [...prev.visible_fields],
          hidden_fields: [...prev.hidden_fields, data],
        };
      }
    });

    setMySpaceVisibleFields(containerId, {
      visible_fields: columnVisibility.visible_fields,
      hidden_fields: columnVisibility.hidden_fields,
    });
  };

  useEffect(() => {
    // Subtracting to total count to remove empty entry at the last.
    setTotalCount(mySpaceBody?.length - 1);
  }, [mySpaceBody]);

  // When click on file, the headerAPI will be called and update the table content.
  useEffect(() => {
    if (containerId) {
      fetchMySpaceHeaderConfig(containerId);
    }
  }, [containerId]);

  useEffect(() => {
    if (isApiLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isApiLoading]);

  useEffect(() => {
    if (customerTableALL) {
      setMultiData({});
    }
  }, [customerTableALL]);

  useEffect(() => {
    if (location.key) {
      dispatch(getUserTokeData());
    }
  }, [location.key]);

  // useEffect(() => {
  //   setheaderProps({ name: "VADS Consulting Pvt. Ltd." });
  //   document.title = "Zinancial | My Space";

  //   return () => {
  //     setheaderProps(null);
  //     document.title = "Zinancial";
  //   };
  // }, [setheaderProps]);

  useEffect(() => {
    if (!menuVisible) {
      setIsMangeHovered(false);
    }
  }, [menuVisible]);

  useEffect(() => {
    setTableColumnsVisibility(() => {
      let fields = {};
      columnVisibility?.visible_fields?.forEach((field) => {
        fields[field] = true;
      });
      columnVisibility?.hidden_fields?.forEach((field) => {
        fields[field] = false;
      });
      return {
        ...fields,
      };
    });
  }, [columnVisibility]);

  useEffect(() => {
    if (containerId) {
      const columnOrderLocalState = getMySpaceColumnOrder(containerId);
      const visibleFieldsLocalState = getMySpaceVisibleFields(containerId);
      if (visibleFieldsLocalState) {
        setColumnVisibility(visibleFieldsLocalState);
      }
      setColumnOrder(columnOrderLocalState || []);
    }
  }, [containerId]);

  // useEffect(() => {
  //   setContainerId(urlContainerId);
  //   setShowListView(type === "tables");
  // }, [urlContainerId, type]);

  return (
    <Fragment>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          // Optional: reset state, refetch, or navigate to safe path
          window.location.reload();
        }}
      >
        <div className=" h-full" id="innercontent">
          {true && (
            <div
              id="default-styled-tab-content"
              className="tablemaindiv h-full"
              // style={{ display: showListView ? "block" : "none" }}
            >
              <div className={`h-full `} id="styled-profile" role="tabpanel" aria-labelledby="profile-tab">
                <div className="h-full">
                  <CustomerReactTable
                    headers={columns || []}
                    body={memoizedCustomerData || []}
                    tableDetail={{
                      tableFilter: (
                        <>
                          <InternalNavigation items={subNavitems} subTabValue={"dashboard"} />
                        </>
                      ),
                    }}
                    // isMySpace
                    isCustomModule
                    fetchPersonInTable={fetchPersonData}
                    rawHeaders={headerConfigData}
                    fetchtableBodyData={fetchFieldOptions}
                    customerCommnData={fieldOptionsData}
                    TableFieldUpdate={handleTableFieldUpdate}
                    noExcelDownload={false}
                    ExtraFields={
                      <div className="flex items-center h-full">
                        <div>
                          {isModalOpen && (
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                              <div className="bg-white p-5 rounded shadow-lg w-[530px]">
                                <div className="flex  justify-between border-b-2">
                                  <h2 className="text-16 font-500 mb-2 text-[#434852] ">Save as View</h2>
                                  <ClosePopUpIcn onClick={closeModal} />
                                </div>
                                <div className="pt-2">
                                  <h1 className="mb-1 text-[#434852] text-14 font-400">Name</h1>
                                  <input className="border-[#DFE2E5] w-[490px] pl-2 text-[#4F4F4F] text-12"></input>
                                </div>
                                <div className="sticky bottom-0 pt-4 flex justify-between  text-md w-full rounded-none z-[9998]">
                                  <div className="space-x-1 text-[#2999BC]">
                                    <input
                                      className="focus:outline-none focus:ring-0 border-[#2999BC] rounded-sm"
                                      type="checkbox"
                                      id="check1"
                                      name="check1"
                                      value="Bike"
                                    />
                                    <label for="check1"> Make It Public</label>
                                  </div>
                                  <div className="">
                                    <button
                                      onClick={closeModal}
                                      type="button"
                                      className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-normal px-5 py-1 text-center rounded-5px"
                                    >
                                      CANCEL
                                    </button>
                                    <button
                                      onClick={closeModal}
                                      type="submit"
                                      className="w-28 text-white bg-1D4469 hover:bg-20486F ok-btn font-normal border border-gray-200 py-1 px-5 ms-3 rounded-5px"
                                    >
                                      OK
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="flex items-center ml-1 ">
                          {Object.keys(multiData)?.length > 0 && (
                            <div>
                              <button
                                onClick={() => {
                                  setIsActive(!isActive);
                                  setShowConfirmDialog({
                                    show: true,
                                    data: {
                                      title: "Delete",
                                      message: "Are you sure want to delete Selected Items?",
                                      callback: deleteBulkRowsInTable,
                                      variant: "delete",
                                      confirmText: "Delete",
                                      cancelText: "Cancel",
                                    },
                                  });
                                }}
                                className={`flex items-center gap-2 py-1 px-2 rounded 
                  ${isActive ? "bg-red-100 text-red-600" : "text-red-600 hover:bg-red-100"}
                `}
                              >
                                <DeleteIcon />
                                Delete
                              </button>
                            </div>
                          )}
                          {/* <ToolTipComponent text="Add New Item"> */}
                          {/* <button
                            onClick={() => {
                              handleAddRow();
                              setSelectedtableRowId(null);
                              setIsActiveAddItem(true);
                            }}
                            
                            className="group flex items-center gap-2 py-1 px-2 rounded text-gray-600 mx-2 border border-transparent hover:text-[#004EFF] hover:border-[#004EFF] active:text-[#0030B3] active:border-[#0030B3] transition-colors duration-200"
                          >
                            
                            <AddItemplus className="text-gray-600 fill-bg:[#004EFF] group-hover:text-[#004EFF] group-active:text-[#0030B3] transition-colors duration-200" />
                          </button> */}

                          <button
                            onClick={() => {
                              handleAddRow();
                              setSelectedtableRowId(null);
                              setIsActiveAddItem(true);
                            }}
                            className="group flex items-center  py-1  rounded text-gray-600 
                  border border-transparent hover:border-[#004EFF] transition-colors duration-200"
                          >
                            <AddItemPlus isActive={isActiveAddItem} />
                          </button>

                          {/* </ToolTipComponent> */}
                          {/* <ToolTipComponent text="Add Field">
                            <span
                              onClick={() => {
                                // handleAddCustomer();
                                setExtraField(true);
                              }}
                              className="cursor-pointer"
                            >
                              <PlusIcon isActive={false} isHovered={false} />
                            </span>
                          </ToolTipComponent> */}
                          {/* <ToolTipComponent text="Manage View" style={{ color: "#1D4469 " }}>
                            <span
                              onClick={() => setMenuVisible((prev) => !prev)}
                              className="cursor-pointer  border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                            >
                              <ManageIcon isActive={menuVisible} isHovered={isMangeHovered} />
                            </span>
                          </ToolTipComponent> */}
                        </div>
                      </div>
                    }
                    currentPage={currentPage}
                    narrowHeader
                    setCurrentPage={setCurrentPage}
                    columnOrder={columnOrder}
                    setColumnOrder={setColumnOrder}
                    totalCount={totalCount}
                    multiData={multiData}
                    setMultiData={setMultiData}
                    grouping={grouping}
                    setGrouping={setGrouping}
                    resetPageIndex={resetPageIndex}
                    setResetPageIndex={setResetPageIndex}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    showColumnEdit={true}
                    showColumnDelete={true}
                    editColumnCallBack={handleEditColumn}
                    columnVisibility={tableColumnsVisibility}
                    setColumnVisibility={setTableColumnsVisibility}
                    deleteColumnCallBack={(columnId) => {
                      setShowConfirmDialog({
                        show: true,
                        data: {
                          title: "Delete",
                          message: "Are you sure want to delete this column?",
                          callback: () => handleDeleteColumn(columnId),
                          variant: "delete",
                          confirmText: "Delete",
                          cancelText: "Cancel",
                        },
                      });
                    }}
                    rowClickDisabled={true}
                    headerConfigData={headerConfigData}
                    isMySpaceCreateColumnHtml={isMySpaceCreateColumnHtml}
                    noMenuOpenList={["is_deletable", "select"]}
                    apiStates={{
                      header: {
                        isLoading: false,
                        isError: false,
                      },
                      body: {
                        isLoading: false,
                        isError: false,
                      },
                    }}
                    alternateDivs={{
                      emptyData: (
                        <>
                          <div className="w-full h-full">
                            <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                              {/* <NoCustomerData className="h-[300px] w-[300px]" /> */}
                              <span className="text-14 text-[#666666] text-sm font-400 font-inter ">
                                No Customer Data is Available.
                              </span>
                            </div>
                          </div>
                        </>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {/* {showCsvUploadPreview && (
            <CsvUploadPreview
              csvFileData={csvFileData}
              setCsvFileData={setCsvFileData}
              setShowCsvUploadPreview={setShowCsvUploadPreview}
              currentDirectoryId={containerId}
              mySpaceDocumentList={mySpaceDocumentList}
              showListView={showListView}
            />
          )} */}
          {/* <MySpaceDocument
            setShowListView={setShowListView}
            setContainerId={setContainerId}
            containerId={containerId}
            // queryContainerId={queryContainerId}
            setSelectedRecord={setSelectedRecord}
            setShowCsvUploadPreview={setShowCsvUploadPreview}
            csvFileData={csvFileData}
            setCsvFileData={setCsvFileData}
            mySpaceDocumentList={mySpaceDocumentList}
            setMySpaceDocumentList={setMySpaceDocumentList}
            showListView={showListView || showCsvUploadPreview}
            isShared={isShared}
            type={type}
          /> */}
        </div>

        {extraField && (
          <AddFieldDrawer
            open={extraField}
            onClose={() => {
              setExtraField((prev) => !prev);
              setIsEditableFieldModeActive(null);
            }}
            ExtraFieldAddHeader={handleAddTableColumn}
            EditFieldData={isEditableFieldModeActive}
            handleDeleteOption={(info) => {
              handleDeleteTableColumnOption(info?.field_id, info?.uuid);
            }}
            handleUpdateTableColumn={handleUpdateTableColumn}
            isMySpace={true}
            isBilling={true}
          />
        )}

        {showConfirmDialog?.show && (
          <ConfirmationDialog
            open={showConfirmDialog?.show}
            title={showConfirmDialog?.data?.title}
            message={showConfirmDialog?.data?.message}
            iconVariant={showConfirmDialog?.data?.variant}
            onClose={() => setShowConfirmDialog(() => ({ data: {}, show: false }))}
            onConfirm={() => {
              showConfirmDialog?.data?.callback();
              setShowConfirmDialog(() => ({ data: {}, show: false }));
            }}
            onCancel={() => setShowConfirmDialog(() => ({ data: {}, show: false }))}
            confirmVariant={showConfirmDialog?.data?.variant}
            confirmText={showConfirmDialog?.data?.confirmText}
            cancelText={showConfirmDialog?.data?.cancelText}
          />
        )}

        {showAddEditModal?.show > 0 && (
          <TableListRowAddEditComponent
            open={showAddEditModal?.show > 0}
            onClose={() => {
              setShowAddEditModal({}); // close drawer
              setIsActiveAddItem(false); // reset AddItemPlus icon
            }}
            // onClose={() => setShowAddEditModal({})}
            prefilledFormData={showAddEditModal?.data}
            onSubmit={handleRowAddEditSubmit}
            mode={rowAddEditMode}
          />
        )}

        {menuVisible && (
          <ManageViewDrawer
            thead={headerConfigData}
            listViewData={columnVisibility}
            handleFieldVisibility={handleFieldVisibility}
            setMenuVisible={setMenuVisible}
            menuVisible={menuVisible}
            fieldOptionsData={fieldOptionsData}
            fetchFieldOptions={fetchFieldOptions}
            handleUpdateTableColumn={handleUpdateTableColumn}
            handleReorderFields={handleReorderFields}
            isMySpace={true}
            handleEditColumn={(columnValue) => handleEditColumn({ id: columnValue })}
            setExtraField={() => setExtraField((prev) => !prev)}
            removeFieldApi={(columnValue) => {
              setShowConfirmDialog({
                show: true,
                data: {
                  title: "Delete",
                  message: "Are you sure want to delete this column?",
                  callback: () => handleDeleteColumn({ id: columnValue }),
                  variant: "delete",
                  confirmText: "Delete",
                  cancelText: "Cancel",
                },
              });
            }}
          />
        )}

        {
          <ConfirmationDialogMulti
            open={showDeleteDialog?.id}
            onClose={() => {
              setShowDeleteDialog(false);
            }}
            title="Delete Entire Raw ?"
            message="Are you sure you want to delete the entire raw? This action cannot be undone."
            onConfirm={() => {
              deleteSingleRowInTable([showDeleteDialog?.id]);
            }}
            onCancel={() => {
              setShowDeleteDialog(false);
            }}
            confirmVariant="delete"
            cancelVariant="secondary"
            confirmText="Delete"
            cancelText="Cancel"
            iconVariant="delete"
          />
        }
      </ErrorBoundary>
    </Fragment>
  );
};

export default BillingDashboard;
